/* eslint-disable prettier/prettier */
/* eslint-disable no-undef */
import api from "./ApiService";

const BASE_PATH = `${process.env.REACT_APP_API_BASE_URL}/Mers/County`;

const getCounties = (filters?: {
  name?: string;
  code?: string;
  state?: string;
  stateCode?: string;
}) => {
  const params = new URLSearchParams();
  if (filters?.name?.trim()) params.append("Name", filters.name.trim());
  if (filters?.code?.trim()) params.append("Code", filters.code.trim());
  if (filters?.state?.trim()) params.append("State", filters.state.trim());
  if (filters?.stateCode?.trim())
    params.append("StateCode", filters.stateCode.trim());

  const query = params.toString();
  return api
    .get<any>(query ? `${BASE_PATH}?${query}` : BASE_PATH)
    .then((response: any) => response);
};

const createCounty = (data: any) => {
  return api.post<any>(BASE_PATH, data).then((response: any) => response);
};

const updateCounty = (data: any) => {
  const countyId = data?.Id ?? data?.id;

  if (countyId === null || countyId === undefined || countyId === 0) {
    return Promise.reject(new Error("County Id is required for update."));
  }

  return api
    .put<any>(`${BASE_PATH}/${countyId}`, data)
    .then((response: any) => response);
};

const CountyService = {
  getCounties,
  createCounty,
  updateCounty,
};

export default CountyService;
